export default "__VITE_ASSET__d03fb02a__"